import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0084cc',
        secondary: '#1f9fe9',
        accent: '#0689d2',
        error: colors.red.accent3,
      },
    },
  },
});

export default vuetify;
